import React from 'react';
import styled from 'styled-components';
import Scroll from 'react-scroll';

let JumpElement = 0;

var scroll = Scroll.animateScroll;

const LinkStyle = styled.a`
  display: block;
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  margin: 0 .75rem;
  :focus {
    outline: none;
  }
`;

class HeaderMenu extends React.Component {

  constructor(props) {
    super(props);
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  scrollToTop() {scroll.scrollToTop()}
  scrollToBottom() {scroll.scrollToBottom()}
  scrollTo() {scroll.scrollTo(window.innerHeight)}
  scrollToDown() {scroll.scrollTo(JumpElement)}

  componentDidMount = () => {
    function HeightEletent() {
      const mainElmnt = document.getElementById("main_Element"),
        footerElmnt = document.getElementById("footer_Element"),
        networkElement = document.getElementById("network_Element");
      return (mainElmnt.scrollHeight - (footerElmnt.scrollHeight + networkElement.scrollHeight));
    }
    JumpElement = HeightEletent();
  }

  render() {
    let Jump = '';
    if (this.props.name === 'SERVIÇOS') {
      Jump = this.scrollTo;
    }
    if (this.props.name === 'CONTATO') {
      Jump = this.scrollToBottom;
    }
    if (this.props.name === 'BLOG') {
      Jump = this.scrollToDown;

    }

    return (
      <LinkStyle
        onClick={Jump}
      >
        {this.props.name}
      </LinkStyle>
    );
  }
}

export default HeaderMenu;



// WEBPACK FOOTER //
// ./src/components/Index/Header/HeaderMenu.jsx